import { IFrameModal } from './iframe-modal.component';

export const RefDirective = function ($modal, $timeout) {
  return {
    restrict: 'A',
    scope   : {
      scTitle: '@',
      scRef  : '@',
    },
    link    : (scope, element, attrs) => {
      const onClick = () => {
        scope.scText = element.text();
        const modal = $modal.open({
          template   : require('./iframe-modal.component.html'),
          controller : IFrameModal,
          windowClass: 'iframe-modal',
          scope      : scope,
        });
        modal.opened
          .then(() => {
            $timeout(() => {
              $('.modal-body1').height((window.innerHeight * 0.96 -
              $('.modal-header').outerHeight() -
              $('.modal-footer').outerHeight() - 30));
            }, 100);
          })
          .catch((err) => {
            console.error(err);
          });
        modal.result
          .catch(err => {
            console.error(err);
          });
      };
      element.bind('click', onClick);
      // scope.$on('$destroy', () => {});
    },
  };
};



// WEBPACK FOOTER //
// ./src/shared/ref.directive.js